import { ITagsState } from './types';
import { FetchingStatus, IBookingTag } from 'shared-types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import TagsService, { hardCodedTags } from 'external-services/tags-service';
import { DiaryRootState } from 'app/appRoot/rootReducer';
import { errorStateActions, getAccordionDetail } from 'app/reducers/errorState/slice';
import {CONTACT_MSG, PROBLEMS_MSG, REFRESH_MSG} from 'appRoot/app-error-messages';

const NS = 'tagsSlice';

const initialState: ITagsState = {
  allTags: [],
  status: FetchingStatus.idle,
};

export const loadTags = createAsyncThunk(
  'tags/loadTags',
  async (_, { dispatch, getState }): Promise<IBookingTag[]> => {
    try {
      // Filters out the DELIVERY_TAG_ID when isTakeAwayMode is false.
      const { venueReducer } = getState() as DiaryRootState;
      const tags = await TagsService.getTags();
      return tags
        .filter((tag) => {
          const isDeliveryFeeTag = tag._id === hardCodedTags.DELIVERY_TAG_ID;
          return venueReducer?.isTakeAwayMode ? isDeliveryFeeTag : !isDeliveryFeeTag;
        })
        .map((tag) => ({
          ...tag,
          dynamicIconName: tag.icon,
        }));
      throw 'error'
    } catch (e) {
      console.warn(NS, 'TagsService.getTags error', e);
      dispatch(
        errorStateActions.setErrorState({
          errorTitle: 'Tags error',
          errorMessage: `There was an error while getting tags. \n\n${PROBLEMS_MSG} ${REFRESH_MSG} \n\n${CONTACT_MSG}`,
          accordionDetail: getAccordionDetail(e),
        })
      );
      return [];
    }
  }
);

const tagsSlice = createSlice({
  name: 'tags', // used in action types
  initialState,
  reducers: {
    reset: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loadTags.pending, (state, action) => {
        state.status = FetchingStatus.loading;
      })
      .addCase(loadTags.fulfilled, (state: ITagsState, action) => {
        state.allTags = action.payload;
        state.status = FetchingStatus.succeeded;
      });
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = tagsSlice;
// Extract and export each action creator by name
export { actions as tagsActions };
// Export the reducer, either as a default or named export
export default reducer;
